import React from 'react';
import 'src/styles/fonts/MCGlobalFonts.css';
import Popup from 'src/common/refactoredComponents/popup/Popup';
import Button from 'src/common/components/button/Button';
import TimeOut from 'src/assets/images/Time-Out.svg';
import {
    DesktopView,
    MobileView,
    PopUpDesktopWrap,
    PopUpText,
    PopUpTitleSubText1,
    PopUpTitleSubText2,
    PopUpTitleText,
    SessionOutPopUpDiv,
} from './sessionTimeOut';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const SessionTimeOutPopUp = ({ handleClose, isOpen }) => {
    useEffectWithErrorLogging(() => {
        return () => {
            handleClose();
        };
    }, []);
    return (
        <>
            <Popup
                onClose={handleClose}
                title={' '}
                width={'192px'}
                img={TimeOut}
                imageMarginLeftDesktop={'187px'}
                imageMarginLeftMobile={'148px'}
                id={'utils-session-timeout-popup'}
            >
                <SessionOutPopUpDiv divHeight={'140px'} isOpen={isOpen}>
                    <PopUpText
                        flexGrow={'1'}
                        height={'auto'}
                        font={'14px Avenir Next World'}
                        lineHeight={'20px'}
                    >
                        <DesktopView>
                            <PopUpTitleText>
                                You have been inactive for{' '}
                                {process.env.SESSION_TIMEOUT_POPUP_TIME}{' '}
                                minutes.
                            </PopUpTitleText>
                            <br />
                            <PopUpTitleSubText1>
                                Please respond or you will be logged out to
                                ensure your{' '}
                            </PopUpTitleSubText1>
                            <PopUpTitleSubText2>
                                account's security
                            </PopUpTitleSubText2>
                        </DesktopView>
                        <MobileView>
                            <PopUpTitleText>
                                You have been inactive for{' '}
                                {process.env.SESSION_TIMEOUT_POPUP_TIME}{' '}
                                minutes.
                            </PopUpTitleText>
                            <PopUpTitleSubText1 mobileMarginTop={'1%'}>
                                Please respond or you will be logged out to
                                ensure your{' '}
                            </PopUpTitleSubText1>
                            <PopUpTitleSubText2>
                                account's security
                            </PopUpTitleSubText2>
                        </MobileView>
                    </PopUpText>
                    <PopUpDesktopWrap flexDirection="row-reverse">
                        <Button
                            show={true}
                            width={'100px'}
                            height={'38px'}
                            primary={true}
                            borderRadius={'19px'}
                            margin={'5px'}
                            fontSize={'15px'}
                            fontFamily={'AvenirNextWorld Demi'}
                            clicked={handleClose}
                        >
                            <div style={{ whiteSpace: 'nowrap' }}>{'OK'}</div>
                        </Button>
                    </PopUpDesktopWrap>
                </SessionOutPopUpDiv>
            </Popup>
        </>
    );
};

export default SessionTimeOutPopUp;
